// extracted by mini-css-extract-plugin
export default {"container":"picture_container__5iKE5","art":"picture_art__PPX3e","order":"picture_order__7n6Gf"};